module.exports = __webpack_public_path__ + "img/tiger.1fd0c809.jpg";